module.exports = __webpack_public_path__ + "static/partner_dpc-13cb897c8a8b40d97dd4495702c47969.svg";